export const environment = {
  production: true,
  apiUrl: 'https://api.classifact.nl',
  appCode: 'CFT-APP',
  authentication: {
    clientId: '108ecab5-1cc1-4720-a59e-74cc0db6b29d',
    scope: '*',
    redirectUrl: 'https://app.classifact.nl/auth/callback',
    responseType: 'code',
    codeChallengeMethod: 'S256',
    renewTimeBeforeTokenExpiresInSeconds: 20,
    postLogoutRedirectUrl: 'https://app.classifact.nl/',
    useTenants: true,
    appCallback: '/app/callback'
  }
};
